<template lang="html">

  <section class="games-collection">
    <v-content class="ml-5 ml-md-0">
      <v-row>
        <h1 v-if="headline">{{ headline }}</h1>
      </v-row>
      <v-row v-if="games">
        <v-col xl="2" md="3" sm="4" cols="6" v-bind:key="game.name.en" v-for="game in games" class="pl-0">
          <v-hover v-slot:default="{ hover }">
            <v-card :height="$vuetify.breakpoint.smAndUp ? 300 : 237" :width="$vuetify.breakpoint.smAndUp ? 200 : 158" class="game_card" hover
                    :img="(game.picture_path.includes('http')) ? game.picture_path : thumb_url + game.picture_path"
                    @click.self="() => {$router.push({ name: 'game', params: { slug: game.slug }})}">
              <v-fade-transition>
                <router-link :to="{ name: 'game', params: { slug: game.slug } }">
                  <v-card-title v-if="hover && game.name.en" class="game_card_title">{{ game.name.en }}
                  </v-card-title>
                  <v-card-title v-else-if="hover" class="game_card_title">{{ game.name.en }}
                  </v-card-title>
                </router-link>
              </v-fade-transition>
              <v-fade-transition @click.stop>
                <v-rating v-if="hover && voteable" class="game_rating onhover"
                          half-increments hover dense
                          v-model="game.user_rating" :readonly="!voteable"
                          :color="voteable ? 'primary' : 'white'"
                          background-color="grey"
                          @input="rate($event, game)"
                          @click.stop></v-rating>
              </v-fade-transition>
            </v-card>
          </v-hover>
          <v-rating v-if="showRating && showUserRating" class="game_average_rating" v-model="game.user_rating"
                    half-increments readonly dense
                    small color="primary"></v-rating>
          <v-rating v-if="showRating && !showUserRating" class="game_average_rating" v-model="game.rating"
                    half-increments readonly dense
                    small color="white"></v-rating>
          <v-row class="mt-1" v-if="type === 'recently'">
            <v-col cols="2" class="mt-0 pt-0">
              <v-avatar size="20" v-if="game.user_picture_path" class="avatar">
                <img :src="profile_pic_url + game.user_picture_path" alt="Profilbild"/>
              </v-avatar>
              <v-avatar size="20" v-else class="avatar">
                <v-icon class="avatar_default">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col class="float-left mt-0 pt-0">
              <p>{{ game.username }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-content>
  </section>

</template>

<script lang="js">


import GameService from "@/services/GameService";

export default {
  name:       'game-collection',
  props:      ['user', 'profile_pic_url', 'voteable', 'showRating', 'showUserRating', 'games', 'headline', 'type', 'thumb_url'],
  components: {},
  mounted () {

  },
  created () {
  },
  data () {
    return {}
  },
  methods:  {
    rate (value, game) {
      console.log(game);
      GameService.rate(game.game_id, value)
                 .then(res => {
                   game.rating = res.data.average;
                 })
                 .catch(() => {

                 });
    },
  },
  computed: {}
  ,
}


</script>

<style scoped lang="scss">
.all-games-list {

}

.game_card {
  margin-bottom: 0;
  margin-left: 0;
}

.game_rating {
  position: absolute;
  bottom: 0;
}

.game_rating .v-icon {
  width: 40px;
}
</style>
